function getLocale(language) {
	const defaultLocale = 'en-US';
	const localeMapping = {
		en: 'en-US',
		sv: 'sv-SE',
	};

	if (localeMapping[language]) return localeMapping[language];
	return defaultLocale;
}

export function formatDate(dateString, locale = 'en-US') {
	const options = { day: 'numeric', month: 'long', year: 'numeric' };
	return new Intl.DateTimeFormat(getLocale(locale), options).format(
		new Date(dateString),
	);
}

export function formatTime(dateString, locale = 'en-US') {
	const options = { hour: '2-digit', minute: '2-digit' };
	return new Intl.DateTimeFormat(getLocale(locale), options).format(
		new Date(dateString),
	);
}

export function formatDateTime(dateString, locale = 'en-US') {
	const options = {
		day: 'numeric',
		hour: '2-digit',
		minute: '2-digit',
		month: 'long',
		year: 'numeric',
	};
	return new Intl.DateTimeFormat(getLocale(locale), options).format(
		new Date(dateString),
	);
}

export function isSummerTime() {
	const current_date = new Date();
	const end_date = new Date('2024-08-18');
	const start_date = new Date('2024-07-15');
	return current_date >= start_date && current_date <= end_date;
}
